export const TransactionMockRes = [
  {
    _id: '61226af3ada3eeec92ec5fb5',
    ReferenceNumber: '100000000046349674',
    ChannelName: 'Cash Deposit',
    Description: 'Bank Account Payment',
    Mcc: '9999',
    Merchant: 'Bank Account Payment',
    RewardPoints: 0,
    SettlementDate: '2021-08-22T15:19:04.173Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 922.17,
    TransactionTypeCode: 'D',
    createdAt: '2021-08-22T15:19:15.688Z',
    created_at: '2021-08-22T15:19:04.167Z',
    updated_at: '2021-08-23T07:00:25.916Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a897ada3eeec9220ae61',
    ReferenceNumber: '100000000044950024',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:11:24.143Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 1,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:15:03.385Z',
    created_at: '2021-08-13T17:11:24.140Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a897ada3eeec9220ae62',
    ReferenceNumber: '100000000044950023',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:11:23.817Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 5,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:15:03.385Z',
    created_at: '2021-08-13T17:11:23.817Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a76aada3eeec92207e1b',
    ReferenceNumber: '100000000044949670',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:08:09.297Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 1,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:10:02.263Z',
    created_at: '2021-08-13T17:08:09.293Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a76aada3eeec92207e1d',
    ReferenceNumber: '100000000044949665',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:08:08.937Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 5,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:10:02.263Z',
    created_at: '2021-08-13T17:08:08.937Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a63eada3eeec922043e2',
    ReferenceNumber: '100000000044948836',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:01:03.660Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 1,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:05:02.347Z',
    created_at: '2021-08-13T17:01:03.657Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a63eada3eeec922043e3',
    ReferenceNumber: '100000000044948835',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:01:03.200Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 5,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:05:02.347Z',
    created_at: '2021-08-13T17:01:03.193Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a511ada3eeec92200c9e',
    ReferenceNumber: '100000000044948297',
    ChannelName: 'Cash Deposit',
    Description: 'Bank Account Payment',
    Mcc: '9999',
    Merchant: 'Bank Account Payment',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T16:56:10.520Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 100,
    TransactionTypeCode: 'D',
    createdAt: '2021-08-13T17:00:01.719Z',
    created_at: '2021-08-13T16:56:10.517Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a3e6ada3eeec921fdc69',
    ReferenceNumber: '100000000044947676',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T16:51:00.413Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 1,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T16:55:02.213Z',
    created_at: '2021-08-13T16:51:00.407Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a3e6ada3eeec921fdc6a',
    ReferenceNumber: '100000000044947675',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T16:51:00.030Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 5,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T16:55:02.213Z',
    created_at: '2021-08-13T16:51:00.027Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a897ada3eeec9220ae62',
    ReferenceNumber: '100000000044950023',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:11:23.817Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 5,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:15:03.385Z',
    created_at: '2021-08-13T17:11:23.817Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
  {
    _id: '6116a76aada3eeec92207e1b',
    ReferenceNumber: '100000000044949670',
    ChannelName: 'Debit Adjustment',
    Description: 'Credit Card Card Balance Usage',
    Mcc: '9999',
    Merchant: 'Credit Card Card Balance Usage',
    RewardPoints: 0,
    SettlementDate: '2021-08-13T17:08:09.297Z',
    SettlementStatus: 'Settled',
    TransactionAmount: 1,
    TransactionTypeCode: 'C',
    createdAt: '2021-08-13T17:10:02.263Z',
    created_at: '2021-08-13T17:08:09.293Z',
    updated_at: '2021-08-23T06:00:01.415Z',
    user: '5f931be69752186e0bd64d2a',
  },
];

export const StoreGroupsMock = [
  {
    group_name: 'Jakob’s Grocery Stores',
    store_count: '12 Stores',
  },
];

export const StoreGroupDetailMock = [
  {
    store_name: 'Ratehub.ca',
    store_id: '784MBSOM',
    address: '20 Queen St W Toronto ON',
    status: 'Active',
  },
  {
    store_name: 'Ticketmaster',
    store_id: 'lYS9OYN2',
    address: '1 Blue Jays Way Toronto ON',
    status: 'Active',
  },
];

export const PromotionsMock = [
  {
    promotion_name: 'Test Promo 01',
    start_date: '2021-11-30 05:00 PM',
    end_date: '2021-11-30 05:00 PM',
    status: 'Completed',
    impressions: 0,
    clicks: 0,
    conversions: 0,
  },
];

export const StoreManagerMock = [
  {
    first_name: 'Jakob',
    middle_name: 'Macrae',
    last_name: 'Sawatsky',
    email: 'Jakobtsky@gmail.com',
  },
];

export const StatementMock = [
  {
    statement_date: 'Thursday, May 17, 2021',
    statement_due_date: 'Friday, May 18, 2021',
    amount_owed: '$210.34',
    status: 'incomplete',
  },
];

export const PromotionPerformanceMock = [
  {
    store_name: 'Summary',
    transactions: '1000',
    transaction_amount: '$5000.00',
    rewards_points: '2800',
    owed_to_plastk: '1000.00',
    impressions: '500',
    clicks: '1000',
    conversions: '1000',
  },
  {
    store_name: 'Store #1',
    transactions: '500',
    transaction_amount: '$500.00',
    rewards_points: '1000',
    owed_to_plastk: '1000.00',
    impressions: '500',
    clicks: '1000',
    conversions: '1000',
  },
  {
    store_name: 'Store #2',
    transactions: '1000',
    transaction_amount: '$5000.00',
    rewards_points: '2800',
    owed_to_plastk: '1000.00',
    impressions: '500',
    clicks: '1000',
    conversions: '1000',
  },
  {
    store_name: 'Store #3',
    transactions: '1000',
    transaction_amount: '$5000.00',
    rewards_points: '2800',
    owed_to_plastk: '1000.00',
    impressions: '500',
    clicks: '1000',
    conversions: '1000',
  },
  {
    store_name: 'Store #4',
    transactions: '1000',
    transaction_amount: '$5000.00',
    rewards_points: '2800',
    owed_to_plastk: '1000.00',
    impressions: '500',
    clicks: '1000',
    conversions: '1000',
  },
];
